import { AttachmentPanel } from '../attachments/AttachmentPanel.jsx';

/** Work detail section: completion evidence, certificates and quotes shared by both sides. Props: { work, onChanged }. */
export function WorkAttachments({ work }) {
  if (!work?.id) return null;
  return <section className="account-content-panel">
    <AttachmentPanel scope="work_record" scopeId={work.id} title="Photos and documents" canAdd
      emptyText="No files shared yet. Add photos of the finished work, certificates or quotes."/>
    <p><small>Only the customer and the chosen company can see these files.</small></p>
  </section>;
}
